import { h } from 'preact'
import FirebaseComponent from './FirebaseComponent'
import CreatePassport from './CreatePassport'
import PassportsTable from './PassportsTable'
import VisasTable from './VisasTable'
import CreateVisa from './CreateVisa'

class Travel extends FirebaseComponent {
  constructor() {
    super()
    this.updatePassport = this.updatePassport.bind(this)
  }

  updatePassport(passport) {
    this.setState({ selectedPassport: passport })
  }

  render() {
    return (
      <div>
        <div className="row">
          <div className="col-sm-12"><h4>Passports</h4></div>
          <div className="col-sm-6">
            <PassportsTable selectedPassport={this.updatePassport}/>
          </div>
          <div className="col-sm-6"><CreatePassport/></div>
        </div>
        <div className="row">
          <div className="col-sm-12"><h4>Visas</h4></div>
          <div className="col-sm-6"><VisasTable passport={this.state.selectedPassport}/></div>
          <div className="col-sm-6"><CreateVisa passport={this.state.selectedPassport}/></div>
        </div>
      </div>
    )
  }
}

export default Travel



// WEBPACK FOOTER //
// ./src/Travel.js